export const PayfastSubscriptionFrequency = {
  Monthly: "3",
  Quarterly: "4",
  BiAnnually: "5",
  Annual: "6",
};
